import sibling from "../../../helpers/sibling";

const state = {
  sibling_1: new sibling(),
  sibling_2: new sibling(),
  sibling_3: new sibling(),
  sibling_4: new sibling(),
  sibling_5: new sibling()
}

const mutations = {
  setName(state, payload) {
    state['sibling_' + payload.num].name = payload.value;
  },
  setAge(state, payload) {
    state['sibling_' + payload.num].age = payload.value;
  },
  setSchool(state, payload) {
    state['sibling_' + payload.num].school = payload.value;
  },
  setGrade(state, payload) {
    state['sibling_' + payload.num].grade = payload.value;
  },
}

export default {
  namespaced: true,
  state,
  mutations
}

